export const projectsData = [
  {
    id: 1,
    title: 'Sakhi', 
    category: 'Design',
    year: '2024',
    bgColor: '#051D22',
    deviceType: 'iphone',
    imageUrl: '/projectdata/healthcare/cover.webp',
    videoUrl: '/projectdata/healthcare/intro.mp4',
    desc: 'Research project for medical applications',
    location: 'Gujarat, India',
    gallery: [
      '/projectdata/healthcare/11.webp',
      '/projectdata/healthcare/12.webp', 
      '/projectdata/healthcare/21.webp', 
      '/projectdata/healthcare/11.webp', 
      '/projectdata/healthcare/31.webp', 
      '/projectdata/healthcare/32.webp', 
      '/projectdata/healthcare/41.webp', 
      '/projectdata/healthcare/42.webp', 
      '/projectdata/healthcare/51.webp', 
      '/projectdata/healthcare/52.webp', 
      '/projectdata/healthcare/61.webp', 
      '/projectdata/healthcare/62.webp', 
      '/projectdata/healthcare/71.webp', 
      '/projectdata/healthcare/72.webp', 
      '/projectdata/healthcare/81.webp', 
      '/projectdata/healthcare/82.webp', 
      '/projectdata/healthcare/92.webp',
      '/projectdata/healthcare/91.webp', 
    ]
  },
  {
    id: 2,
    title: '3D Cube',
    category: 'Electronics',
    year: '2022 - 25',
    bgColor: '#080D2A',
    deviceType: 'mac',
    imageUrl: '/projectdata/electronics/cover.webp',
    videoUrl: '/projectdata/electronics/intro.mp4', 
    desc: '3D LED Matrix |  Object Detection | BT-Car | Agro BOT',
    location: 'Gujarat, India',
    gallery: [
      '/projectdata/electronics/11.webp',
      '/projectdata/electronics/cover.webp',
      '/projectdata/electronics/21.webp',
      '/projectdata/electronics/22.webp',
      '/projectdata/electronics/31.webp',
      '/projectdata/electronics/32.webp',
      '/projectdata/electronics/41.webp',
      '/projectdata/electronics/42.webp',
      '/projectdata/electronics/51.webp',
      '/projectdata/electronics/52.webp',
      '/projectdata/electronics/61.webp',
      '/projectdata/electronics/62.webp',
    ]
  },
  {
    id: 3,
    title: 'WeHear',
    category: 'Website',
    year: '2026',
    bgColor: '#382B38',
    deviceType: 'mac',
    imageUrl: '/projectdata/wehear/cover.webp',
    videoUrl: '/projectdata/wehear/intro.mp4', 
    desc: 'Full Stack Web Development \n UI/UX Design',
    location: 'Gujarat, India',
    gallery: [
      '/projectdata/wehear/11.webp',
      '/projectdata/wehear/12.webp',
      '/projectdata/wehear/21.webp',
      '/projectdata/wehear/22.webp',
      '/projectdata/wehear/31.webp',
      '/projectdata/wehear/32.webp',
      '/projectdata/wehear/41.webp',
      '/projectdata/wehear/42.webp',
    ]
  },

      {
    id: 4,
    title: "Ingenium'25",
    category: 'Design',
    year: '2024 - 25',
    bgColor: '#2A2824',
    deviceType: 'mac',
    imageUrl: '/projectdata/ingenium/cover.png', 
    videoUrl: '../projectdata/ingenium/intro.mp4', 
    desc: 'Ingenium Technical Festival 2025 | Design Head | Hackathon Head | Web Designer | Gaming Event Head ',
    location: 'Gujarat, India',
    gallery: [
      '/projectdata/ingenium/11.png',
      '/projectdata/ingenium/12.png',
      '/projectdata/ingenium/21.png',
      '/projectdata/ingenium/22.png',
      '/projectdata/ingenium/31.png',
      '/projectdata/ingenium/32.png',
      '/projectdata/ingenium/41.png',
      '/projectdata/ingenium/42.png',
      '/projectdata/ingenium/51.png',
      '/projectdata/ingenium/52.png',
      '/projectdata/ingenium/61.png',
      '/projectdata/ingenium/62.png',
      '/projectdata/ingenium/71.png',
      '/projectdata/ingenium/72.png',
      '/projectdata/ingenium/81.png',
      '/projectdata/ingenium/82.png',
    ]
  },
  {
    id: 5,
    title: "Ingenium'26",
    category: 'Design',
    year: '2026',
    bgColor: '#2A2824',
    deviceType: 'mac',
    imageUrl: '/projectdata/tshirt/cover.webp', 
    videoUrl: '../projectdata/tshirt/intro.mp4', 
    desc: 'Tshirt Design | Published process of design journey.',
    location: 'Gujarat, India',
    gallery: [
      '/projectdata/tshirt/11.webp',
      '/projectdata/tshirt/12.webp',
      '/projectdata/tshirt/21.webp',
      '/projectdata/tshirt/22.webp',
    ]
  },


];